var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('navbar',{attrs:{"title":"Hoppsan","back-link":"Tillbaka"}}),_vm._v(" "),_c('f7-block',{attrs:{"strong":""}},[_c('p',[_vm._v("Sidan hittades inte.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }